import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'tnt-maintenance',
  templateUrl: './maintenance.component.html',
  // styleUrls: ['./maintenance.component.scss']
  host: { 'style': 'width: 100%' },
})
export class TntMaintenanceComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit() { }

}
